<div class="bv-table-wrapper">
    <div class="bv-table-scroll">
        <table mat-table [dataSource]="dataSource">
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [@fadein] [class.row-inactive]="row.inactive"></tr>
            <ng-container *ngFor="let col of columns" [matColumnDef]="col.caption">
                <th mat-header-cell *matHeaderCellDef [ngClass]="col.largeCol ? 'col-md-5' : ''" (click)="clClicked(col.caption, orderDesc)">
                    <ng-container *ngIf="col.type !== 'selection'">
                        <span *ngIf="!col.order">{{col.caption | translate}}</span>
                        <span *ngIf="col.order" class="col-pointer" title="{{'LABELS.CLICKORDER' | translate}}">{{col.caption | translate}}
                            <span class="bv-sort-indicator">
                               <mat-icon *ngIf="columnOrder === col.caption" class="bv-sort-icon">{{ orderDesc ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
                            </span>
                        </span>
                    </ng-container>
                    <ng-container *ngIf="col.type === 'selection'" class="selection-button">
                        <mat-checkbox (change)="$event ? masterToggle() :
                            null" [checked]="selection.hasValue() && allSelected"
                            [indeterminate]="selection.hasValue() && !allSelected">
                        </mat-checkbox>
                    </ng-container></th>
                <td mat-cell *matCellDef="let element" [ngClass]="largeTable ? 'mat-column' : ''">
                    <ng-container [ngSwitch]="col.type">
                        <span *ngSwitchCase="columnTypes.detailed">
                            <div class="bv-detailed-col">
                                <div *ngIf="expanded !== element.id" [@fadein] class="bv-detailed-chips">
                                    <span *ngIf="col.field !== 'individuals'">
                                        <span *ngIf="element[col.field]?.[0]?.description" class="bv-badge bv-badge--neutral">
                                            {{ col.translate ? (element[col.field]?.[0]?.description | translate) : element[col.field]?.[0]?.description }}
                                        </span>
                                    </span>
                                    <span *ngIf="col.field === 'individuals'">
                                        <a class="link" *ngIf="element[col.field]?.[0]?.individual_vinculate_company_id"
                                            [routerLink]="'/company/'+element[col.field]?.[0]?.individual_vinculate_company_id">
                                            <span class="bv-badge bv-badge--neutral">{{element[col.field]?.[0]?.description}}</span>
                                        </a>
                                        <a class="link"
                                            *ngIf="!(element[col.field]?.[0]?.individual_vinculate_company_id)"
                                            [routerLink]="'/individuals/profile/'+element[col.field]?.[0]?.id">
                                            <span class="bv-badge bv-badge--neutral">{{element[col.field]?.[0]?.description}}</span>
                                        </a>
                                    </span>
                                </div>

                                <div *ngIf="expanded === element.id" [@fadein] class="bv-detailed-chips">
                                    <div *ngFor="let item of element[col.field]" class="bv-detailed-chip-row">
                                        <span *ngIf="col.field !== 'individuals'">
                                            <span class="bv-badge bv-badge--neutral">
                                                {{ col.translate ? (item.description | translate) : item.description }}
                                            </span>
                                        </span>
                                        <span *ngIf="col.field === 'individuals'">
                                            <a class="link" *ngIf="item.individual_vinculate_company_id"
                                                [routerLink]="'/company/'+item.individual_vinculate_company_id">
                                                <span class="bv-badge bv-badge--neutral">{{item.description}}</span>
                                            </a>
                                            <a class="link" *ngIf="!(item.individual_vinculate_company_id)"
                                                [routerLink]="'/individuals/profile/'+item.id">
                                                <span class="bv-badge bv-badge--neutral">{{item.description}}</span>
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="show-more" *ngIf="element[col.field]?.length>1"
                                (click)="showDetail(element.id)">{{ expanded === element.id
                                ? ('LABELS.SEE_LESS' | translate)
                                : ('LABELS.SEE_X_MORE' | translate:{count: element[col.field].length - 1}) }}
                            </div>
                        </span>
                        <span *ngSwitchCase="columnTypes.checkbox">
                            <input type="checkbox" class="form-check-input form-check-input-fix" mat-checkbox
                                name="stock_paid" id="stock_paid" [checked]="element[col.field]"
                                (click)="actClicked(col.actionType , element)" />
                        </span>
                        <span *ngSwitchCase="columnTypes.checkboxReadonly">
                            <div *ngIf="element[col.field]">
                                <mat-icon class="bv-icon--primary">done</mat-icon>
                            </div>
                        </span>
                        <span *ngSwitchCase="columnTypes.list">
                            <div class="list-col" *ngFor="let item of element[col.field]">{{item.description}}
                            </div>
                        </span>
                        <span *ngSwitchCase="columnTypes.chips">
                            <div class="bv-chips">
                                <span *ngFor="let chip of element[col.field] | slice:0:(col.maxChips || 3)"
                                    class="bv-chip"
                                    [ngStyle]="chip[col.chipColorField || 'color'] ? {'background-color': chip[col.chipColorField || 'color']} : null">
                                    {{ chip[col.chipLabelField || 'name'] }}
                                </span>
                                <span *ngIf="element[col.field]?.length > (col.maxChips || 3)" class="bv-chip bv-chip--more">
                                    +{{ element[col.field].length - (col.maxChips || 3) }}
                                </span>
                                <span *ngIf="!element[col.field]?.length" class="bv-chip bv-chip--empty">—</span>
                            </div>
                        </span>
                        <span *ngSwitchCase="columnTypes.selection">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? handleSelection(element) :
                            null" [checked]="selection.isSelected(element)">
                            </mat-checkbox>
                        </span>
                        <span *ngSwitchCase="columnTypes.date" class="bv-cell--padded">
                            {{ element[col.field] | date: 'dd/MM/yyyy'}}
                        </span>
                        <span *ngSwitchCase="columnTypes.badge">
                            <span *ngIf="element[col.field]" class="bv-badge"
                              [class.bv-badge--primary]="col.badgeVariants?.[element[col.colorField]] === 'primary'"
                              [class.bv-badge--success]="col.badgeVariants?.[element[col.colorField]] === 'success'"
                              [class.bv-badge--warning]="col.badgeVariants?.[element[col.colorField]] === 'warning'"
                              [class.bv-badge--danger]="col.badgeVariants?.[element[col.colorField]] === 'danger'"
                              [class.bv-badge--neutral]="!col.badgeVariants?.[element[col.colorField]] || col.badgeVariants?.[element[col.colorField]] === 'neutral'">
                                {{ col.translate ? (element[col.field] | translate) : element[col.field] }}
                            </span>
                            <span *ngIf="!element[col.field]" class="bv-badge bv-badge--neutral">
                                {{ (col.emptyLabel || 'LABELS.NOT_APPLICABLE') | translate }}
                            </span>
                        </span>
                        <span *ngSwitchCase="columnTypes.dateBadge">
                            <span *ngIf="element[col.field]" class="bv-badge bv-badge--neutral">
                                {{ element[col.field] | date: 'dd/MM/yyyy' }}
                            </span>
                            <span *ngIf="!element[col.field]" class="bv-badge bv-badge--neutral">
                                {{ 'LABELS.NOT_APPLICABLE' | translate }}
                            </span>
                        </span>
                        <span *ngSwitchCase="columnTypes.percentage" class="bv-cell--padded">
                            {{ element[col.field] | customRound:'.10-10'}} %
                        </span>

                        <span *ngSwitchCase="columnTypes.regular" class="d-flex align-items-center">
                            <ng-container *ngIf="col.uppercase">
                                {{ element[col.field] | uppercase }}
                            </ng-container>
                            <ng-container *ngIf="!col.uppercase && col.translate">
                                {{ element[col.field] | translate}}
                            </ng-container>
                            <ng-container *ngIf="!col.uppercase && !col.translate">
                                {{ element[col.field]}}
                            </ng-container>
                        </span>
                        <span *ngSwitchCase="columnTypes.combination" class="d-flex align-items-center">
                            <ng-container>
                                {{ element[col.field] }} {{ element[col.fieldOfCombination] }}
                            </ng-container>
                        </span>
                        <span *ngSwitchCase="columnTypes.link">
                            <div
                                *ngIf="col.fieldOfRedirection === 'individual_id' && element.individual_vinculate_company_id">
                                <a class="link" [routerLink]="'/company/'+element.individual_vinculate_company_id">
                                    {{ element[col.field] }}
                                </a>
                            </div>
                            <div
                                *ngIf="!(col.fieldOfRedirection === 'individual_id' && element.individual_vinculate_company_id)">
                                <a class="link"
                                    [routerLink]="col.linkToRedirectTo + (col.fieldOfRedirection !== '' ? element[col.fieldOfRedirection]: '')">
                                    {{ element[col.field] }}
                                </a>
                            </div>

                        </span>
                        <span *ngSwitchCase="columnTypes.iconLink" class="ml-3">
                            <a class="link"
                                [routerLink]="col.linkToRedirectTo + (col.fieldOfRedirection !== '' ? element[col.fieldOfRedirection]: '')">
                                <mat-icon class="material-icons light-grey">{{col.icon}}</mat-icon>
                                <mat-icon *ngIf="col.svgIcon" [svgIcon]="col.svgIcon"></mat-icon>
                            </a>
                        </span>
                        <span *ngSwitchCase="columnTypes.textAction">
                            <a class="link" (click)="actClicked(col.actionType, element)">
                                {{ element[col.field] }}
                            </a>
                        </span>
                        <span *ngSwitchCase="columnTypes.iconAction" class="ml-3">
                            <a [title]="col.actionTitle | translate" (click)="actClicked(col.actionType , element)">
                                <mat-icon *ngIf="col.icon" [ngStyle]="{'color': col.iconColor}"
                                    class="material-icons light-grey">
                                    {{col.icon}}</mat-icon>
                                <mat-icon *ngIf="col.svgIcon" [svgIcon]="col.svgIcon"></mat-icon>
                            </a>
                        </span>
                        <span *ngSwitchCase="columnTypes.iconMultiAction" class="container-icons">
                            <span *ngFor="let action of col.multiActionIcons">
                                <a *ngIf="action.link && !action.conditional"
                                    [routerLink]="action.link + element[action.fieldOfRedirection]"
                                    [title]="action.actionTitle  | translate"
                                    (click)="actClicked(action.actionType , element)">
                                    <mat-icon *ngIf="action.icon" class="bv-action-icon" [attr.data-action]="action.actionType">{{action.icon}}</mat-icon>
                                    <mat-icon *ngIf="action.svgPath" [svgIcon]="col.svgPathOn"></mat-icon>
                                    <mat-icon *ngIf="action.svgIcon" [svgIcon]="action.svgIcon"></mat-icon>

                                </a>
                                <a *ngIf="action.linkDynamic"
                                    [routerLink]="element[action.linkDynamic] + element[action.fieldOfRedirection]"
                                    [title]="action.actionTitle  | translate"
                                    (click)="actClicked(action.actionType , element)">
                                    <mat-icon *ngIf="action.icon" class="bv-action-icon" [attr.data-action]="action.actionType">{{action.icon}}</mat-icon>
                                    <mat-icon *ngIf="action.svgPath" [svgIcon]="col.svgPathOn"></mat-icon>
                                    <mat-icon *ngIf="action.svgIcon" [svgIcon]="action.svgIcon"></mat-icon>

                                </a>
                                <a *ngIf="action.actionType && !action.conditional"
                                    [title]="action.actionTitle  | translate"
                                    (click)="actClicked(action.actionType , element)">
                                    <mat-icon *ngIf="action.icon" class="bv-action-icon"
                                      [attr.data-action]="action.actionType"
                                      [class.bv-action-icon--linked]="action.actionType === 'linkDocs' && element[col.field]">{{action.icon}}</mat-icon>
                                    <mat-icon *ngIf="action.svgPath" [svgIcon]="col.svgPathOn"></mat-icon>
                                    <mat-icon *ngIf="action.svgIcon" [svgIcon]="action.svgIcon">
                                    </mat-icon>

                                </a>
                                <a *ngIf="action.actionType && action.conditional && element[action.fieldOfCondition]"
                                    [title]="action.actionTitle  | translate"
                                    (click)="actClicked(action.actionType , element)">
                                    <mat-icon *ngIf="action.icon" class="bv-action-icon"
                                      [attr.data-action]="action.actionType"
                                      [class.bv-action-icon--linked]="action.actionType === 'linkDocs' && element[col.field]">{{action.icon}}</mat-icon>
                                    <mat-icon *ngIf="action.svgPath" [svgIcon]="col.svgPathOn"></mat-icon>
                                    <mat-icon *ngIf="action.svgIcon" [svgIcon]="action.svgIcon"></mat-icon>
                                </a>
                                <a *ngIf="action.link && action.conditional && element[action.fieldOfCondition]"
                                    [routerLink]="element[action.link] + element[action.fieldOfRedirection]"
                                    [title]="action.actionTitle  | translate"
                                    (click)="actClicked(action.actionType , element)">
                                    <mat-icon *ngIf="action.icon" class="bv-action-icon"
                                      [attr.data-action]="action.actionType"
                                      [class.bv-action-icon--linked]="action.actionType === 'linkDocs' && element[col.field]">{{action.icon}}</mat-icon>
                                    <mat-icon *ngIf="action.svgPath" [svgIcon]="col.svgPathOn"></mat-icon>
                                    <mat-icon *ngIf="action.svgIcon" [svgIcon]="action.svgIcon"></mat-icon>

                                </a>
                            </span>
                        </span>
                        <span *ngSwitchCase="columnTypes.regularWMulticolorIcons" class="d-flex align-items-center">
                            <mat-icon *ngIf="element['deletable'] && element['resolved']"
                                class="material-icons icon-size" [ngStyle]="{'color':'green'}" size="large">check
                            </mat-icon>

                            <mat-icon *ngIf="!element['deletable'] || (element['deletable'] && element['notResolved']) "
                                class="material-icons icon-size"
                                [ngStyle]="{'color': col.colors[element[col.colorField]]}" size="large">{{col.icon}}
                            </mat-icon>
                            {{ element[col.field] | translate}}
                        </span>
                        <span *ngSwitchCase="columnTypes.toggleSvgIcon">
                            <button mat-icon-button (click)="actClicked(col.actionType ,element)"
                              class="bv-toggle-icon">
                                <mat-icon *ngIf="element[col.field]" class="bv-icon--favorite-on">star</mat-icon>
                                <mat-icon *ngIf="!element[col.field]" class="bv-icon--favorite-off">star_border</mat-icon>
                            </button>
                        </span>
                    </ng-container>
                </td>
            </ng-container>
        </table>
        <div class="empty-response" [ngStyle]="{height: (pageSize * 3).toString() + 'rem'}"
            *ngIf="dataSource?.length === 0 && !loading">
            <mat-icon class="material-icons icon-size" size="large">search_off</mat-icon>
            {{'TABLES.EMPTY' | translate}}
        </div>
        <div class="bv-table-loading" *ngIf="loading">
            <mat-icon class="bv-spinner">sync</mat-icon>
        </div>
        <ng-content select="[paginator]"></ng-content>
    </div>
</div>